import { useShowAlert } from '~/composables/use-show-alert'

export function useLogError() {
    const showAlert = useShowAlert()
    return (error: unknown) => {
        if (import.meta.env.DEV) {
            showAlert('Error', String(error))
            // eslint-disable-next-line no-console
            console.error(error)
        }
    }
}
